import React from "react";

const ProductCard = ({ data }) => {
  return (
    <div>
        <div className="" style={{display:"flex",alignItems:"center",gap:'10px'}}>
        <div style={{backgroundImage:`url(${data?.image})`,backgroundSize:"cover",backgroundPosition:"center",backgroundRepeat:'no-repeat',height:"120px",width:'120px'}}></div>
      <div
        className="order-item"
        style={{
            marginBottom: "16px",
            display: "flex",
            flexDirection: "column",
            gap: "6px",
        }}
      >
        <span style={{ fontWeight: "600" }}>{data?.title}</span>
        <span>{`$${data?.price}`}</span>
        <span>{`Size: ${data?.size}`}</span>
      </div>
    </div>
    <hr style={{color:'gray'}} />
    </div>
  );
};

export default ProductCard;
